module.exports = __webpack_public_path__ + "static/rocket_logo_white-f3eaea77ae29ea633a6055686458a6eb.png";